import { useEcosystems, UseEcosystemsReturn } from "@/hooks/useEcosystems";
import { createContext, ReactNode, useContext } from "react";

const EcosystemContext = createContext<UseEcosystemsReturn | undefined>(undefined);

export const useEcosystemContext = () => {
  const context = useContext(EcosystemContext);
  if (!context) {
    throw new Error("useEcosystemContext must be used within a EcosystemProvider");
  }
  return context;
};

export const EcosystemProvider = ({ children }: { children: ReactNode }) => {
  const ecosystemData = useEcosystems();
  return <EcosystemContext.Provider value={ecosystemData}>{children}</EcosystemContext.Provider>;
};
